import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function MenuItem({ className, onClick, children }) {
  return <Lib.MenuItem className={className} onClick={onClick}>{children}</Lib.MenuItem>
}

MenuItem.defaultProps = {
  className: '',
  onClick: () => null,
}

MenuItem.propTypes = {
  children: PropType.node.isRequired,
  className: PropType.string,
  onClick: PropType.func,
}

export default MenuItem
